<li
  class="live-feed-item"
  draggable="true"
  [ngClass]="{dragged: dragged, 'list-mode': viewMode == 'list'}"
>
  <section>
    <icn-image
      [url]="item.thumbnail"
      [defaultImage]="'/assets/icons/live-icon.svg'"
    ></icn-image>
    <div class="hover-layer" [ngClass]="{menuActive: menuOpen}">
      <section>
        <button
          *ngIf="currentUser && currentUser.isSuperUser"
          data-title="THUMBNAIL"
          class="upload-thumbnail"
        >
          <img src="/assets/icons/upload-thumbnail.png" />
          <input
            type="file"
            accept="image/*"
            (change)="onUploadThumbnail($event)"
          />
        </button>
        <button
          *ngIf="currentUser && currentUser.isSuperUser"
          data-title="EDIT"
          (click)="editLiveFeed()"
        >
          <svg>
            <g>
              <path
                d="M7.2,19.6l-0.4-0.1c-0.7-0.2-1.3-0.5-1.9-0.8l-0.3-0.2l0.1-0.4c0.3-1,0.1-1.8-0.6-2.5C3.3,15,2.5,14.8,1.5,15
                            l-0.4,0.1l-0.2-0.3c-0.3-0.6-0.6-1.3-0.8-1.9L0,12.5l0.3-0.2c0.9-0.5,1.5-1.5,1.5-2.5C1.9,8.7,1,8,0.3,7.6L0,7.4L0.1,7
                            c0.2-0.7,0.5-1.3,0.8-1.9l0.2-0.3l0.4,0.1C2.4,5,3.2,4.8,4,4c0.7-0.7,0.9-1.5,0.6-2.5L4.5,1.1l0.3-0.2c0.6-0.3,1.3-0.6,1.9-0.8
                            L7.2,0l0.2,0.3c0.5,0.9,1.5,1.5,2.5,1.5s1.9-0.6,2.5-1.5L12.5,0l0.4,0.1c0.7,0.2,1.3,0.5,1.9,0.8l0.3,0.2L15,1.5
                            c-0.3,1-0.1,1.8,0.6,2.5c0.8,0.8,1.6,1.1,2.5,0.8l0.4-0.1l0.2,0.3c0.3,0.6,0.6,1.3,0.8,1.9l0.1,0.4l-0.3,0.2
                            c-0.7,0.4-1.5,1.1-1.5,2.3c0,1.1,0.8,1.8,1.5,2.3l0.3,0.2l-0.1,0.4c-0.2,0.7-0.5,1.3-0.8,1.9l-0.2,0.3l-0.4-0.1
                            c-0.9-0.2-1.7,0-2.5,0.8c-0.7,0.7-0.9,1.5-0.6,2.5l0.1,0.4l-0.3,0.2c-0.6,0.3-1.3,0.6-1.9,0.8l-0.4,0.1l-0.2-0.3
                            c-0.5-0.9-1.5-1.5-2.5-1.5c-1,0-1.9,0.6-2.5,1.5L7.2,19.6z M9.8,16.8L9.8,16.8c1.2,0,2.4,0.6,3.1,1.7c0.4-0.1,0.7-0.3,1.1-0.4
                            c-0.2-1.2,0.1-2.2,1-3.1c0.9-0.9,2-1.3,3.1-1.2c0.2-0.3,0.3-0.7,0.4-1.1c-1.1-0.8-1.7-1.8-1.7-2.9c0-1.1,0.6-2.1,1.7-2.9
                            c-0.1-0.4-0.3-0.7-0.4-1.1C16.9,6,15.9,5.6,15,4.7c-0.8-0.8-1.2-1.9-1-3.1c-0.3-0.2-0.7-0.3-1.1-0.4c-0.7,1-1.9,1.7-3.1,1.7
                            S7.5,2.2,6.7,1.2C6.3,1.3,6,1.5,5.7,1.6c0.2,1.2-0.1,2.2-1,3.1C3.7,5.6,2.7,6,1.6,5.9C1.5,6.2,1.3,6.6,1.2,6.9
                            c1.1,0.7,1.7,1.8,1.7,2.9c0,1.2-0.6,2.4-1.7,3.1c0.1,0.4,0.3,0.7,0.4,1.1c1.2-0.2,2.2,0.1,3.1,1c0.8,0.8,1.2,1.9,1,3.1
                            c0.3,0.2,0.7,0.3,1.1,0.4C7.5,17.4,8.6,16.8,9.8,16.8z M9.8,14.3c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5s4.5,2,4.5,4.5
                            S12.3,14.3,9.8,14.3z M9.8,6.3c-1.9,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5S11.8,6.3,9.8,6.3z"
              />
            </g>
          </svg>
        </button>
        <button data-title="PREVIEW">
          <preview-button (click)="previewLiveFeed()"></preview-button>
        </button>
        <button
          *ngIf="currentUser && currentUser.isSuperUser"
          data-title="DELETE"
          (click)="deleteLiveFeed()"
        >
          <svg>
            <g>
              <path
                d="M19,2h-2v0h-2V0H4v2H2v0H0V3h2v15h15V3h2V2z M4.9,0.9h9.2V2H4.9V0.9z M16.1,17.1H2.9V3H4v0h11v0h1.1V17.1z"
              />
              <rect x="6" y="5" width="1" height="10" />
              <rect x="9" y="5" width="1" height="10" />
              <rect x="12" y="5" width="1" height="10" />
            </g>
          </svg>
        </button>
      </section>
    </div>
  </section>
  <footer>
    <span>{{item.name}}</span>
    <a *ngIf="viewMode != 'list'">
      <svg>
        <path
          fill-rule="evenodd"
          d="M6.000,6.999 C5.447,6.999 4.999,6.552 4.999,6.000 C4.999,5.447 5.447,4.999 6.000,4.999 C6.551,4.999 6.999,5.447 6.999,6.000 C6.999,6.552 6.551,6.999 6.000,6.999 ZM6.000,1.999 C5.447,1.999 4.999,1.552 4.999,0.999 C4.999,0.447 5.447,-0.001 6.000,-0.001 C6.551,-0.001 6.999,0.447 6.999,0.999 C6.999,1.552 6.551,1.999 6.000,1.999 ZM0.999,11.999 C0.446,11.999 -0.001,11.552 -0.001,10.999 C-0.001,10.447 0.446,9.999 0.999,9.999 C1.552,9.999 1.999,10.447 1.999,10.999 C1.999,11.552 1.552,11.999 0.999,11.999 ZM0.999,6.999 C0.446,6.999 -0.001,6.552 -0.001,6.000 C-0.001,5.447 0.446,4.999 0.999,4.999 C1.552,4.999 1.999,5.447 1.999,6.000 C1.999,6.552 1.552,6.999 0.999,6.999 ZM0.999,1.999 C0.446,1.999 -0.001,1.552 -0.001,0.999 C-0.001,0.447 0.446,-0.001 0.999,-0.001 C1.552,-0.001 1.999,0.447 1.999,0.999 C1.999,1.552 1.552,1.999 0.999,1.999 ZM6.000,9.999 C6.551,9.999 6.999,10.447 6.999,10.999 C6.999,11.552 6.551,11.999 6.000,11.999 C5.447,11.999 4.999,11.552 4.999,10.999 C4.999,10.447 5.447,9.999 6.000,9.999 Z"
        />
      </svg>
    </a>
  </footer>
</li>
